// Therapist Benefit Primary

$(function () {
  $('.jsBlockBenefitCarousel').owlCarousel({
    loop: true,
    nav: true,
    navText:[
      "<svg class=\"icon-chevron-left\"><use xlink:href=\"#icon-chevron-left\"></use></svg>",
      "<svg class=\"icon-chevron-right\"><use xlink:href=\"#icon-chevron-right\"></use></svg>"
    ],
    dots: true,
    items: 1,
    smartSpeed: 500,
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true
  });
})
